import React, { useState } from 'react';
import { useRecoilState } from 'recoil'
import { authState } from '../../../../Atom'
import { loginUserApi } from '../Api'

const LoginForm = () => {


    const [auth, setAuth] = useRecoilState(authState);
    const [loading, setLoading] = useState(false);
    const [userName, setUserName] = useState('');
    const [userPassword, setUserPassword] = useState('');

    //make a sets state for error messgae 
    const [errorMessage, setErrorMessage] = useState('Something Went Wrong !');
    const [isError, setIsError] = useState(false);


    const loginUserFunc = async () => {
        setLoading(true)

        if (userName == '' || userPassword == '') {
            setLoading(false)
            return alert('Username or Password cannot be blank !')
        }


        //check if email is valid and password is 6 characters long otherwise set error message and set isError to true

        if (!(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(userName))) {
            setLoading(false)
            setErrorMessage('Invalid Email !')
            setIsError(true)
            return
        }
        if (userPassword.length < 6) {
            setLoading(false)
            setErrorMessage('Password must be 6 characters long !')
            setIsError(true)
            return
        }

        let data ={
            email : userName,
            password : userPassword
        }

        const res = await loginUserApi(data) ;

        if(res.isError){
            setErrorMessage(res.data+'')
            setIsError(true)
            return setLoading(false)
        }else{
            setAuth({...res.data, isAuth : true })
        }


        setLoading(false)

    }




    return (
        <div className="w-full flex justify-center items-center " >

            <div className="w-full max-w-sm">
                <form className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                    <div className="mb-4 py-2">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
                            Username
                        </label>
                        <input onChange={(e) => setUserName(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder="Username" />
                    </div>
                    <div className="mb-6 py-2">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                            Password
                        </label>
                        <input onChange={(e) => setUserPassword(e.target.value)} className="shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" id="password" type="password" placeholder="******" />

                        {isError && <p className="text-red-500 text-xs italic">{errorMessage}</p>}

                    </div>
                    <div className="flex items-center justify-between my-4">



                        <button onClick={() => loginUserFunc()} className="bg-blue-500 hover:bg-blue-700 text-white font-normal py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button">
                            {loading ? ('Loading...') : ('Login')}
                        </button>

                        <a className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800" >
                            Forgot Password?
                        </a>
                    </div>
                </form>
                <p className="text-center text-gray-500 text-xs">
                    ©2021 Admin Restro. All rights reserved.
                </p>
            </div>


        </div>
    );
}

export default LoginForm;
